import { render, staticRenderFns } from "./MobileRecommend.vue?vue&type=template&id=2a1d88b6&scoped=true"
import script from "./MobileRecommend.vue?vue&type=script&lang=js"
export * from "./MobileRecommend.vue?vue&type=script&lang=js"
import style0 from "./MobileRecommend.vue?vue&type=style&index=0&id=2a1d88b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1d88b6",
  null
  
)

export default component.exports